import { useEffect, useState } from "react";
import { SheetHeader, SheetTitle, SheetDescription } from "@/components/ui/sheet";
import { adapter } from "@/services/db";
import { text, fmtTs, toDate } from "@/lib/format";

// Read-only monitoring of a customer–pro chat thread.
export function ChatViewer({ thread }) {
  const [msgs, setMsgs] = useState([]);
  useEffect(() => adapter.subscribeWhere("chat_messages", [["thread_id", "==", thread.id]], (rows) =>
    setMsgs(rows.sort((a, b) => (toDate(a.sent_at)?.getTime() || 0) - (toDate(b.sent_at)?.getTime() || 0)))), [thread.id]);
  return (
    <>
      <SheetHeader className="text-left"><SheetTitle className="font-heading">{text(thread.title, "Chat")}</SheetTitle><SheetDescription>Customer ↔ professional · read-only · request {text(thread.request_id)}</SheetDescription></SheetHeader>
      <div className="mt-4 space-y-2" data-testid="chat-messages">
        {msgs.map((m) => (
          <div key={m.id} className={`rounded-lg px-3 py-2 text-sm max-w-[85%] ${m.sender_role === "professional" ? "ml-auto bg-indigo-50" : "bg-secondary"}`}>
            <p className="whitespace-pre-wrap break-words">{text(m.body)}</p>
            <p className="text-[10px] text-muted-foreground mt-1 capitalize">{text(m.sender_role)} · {fmtTs(m.sent_at)}</p>
          </div>
        ))}
        {msgs.length === 0 && <p className="text-sm text-muted-foreground">No messages.</p>}
      </div>
    </>
  );
}
